import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { saveAuthSession } from "../constants/authSession";
import { auth, db } from "../api/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { ref, get, set, serverTimestamp } from "firebase/database";
import "../styles/journey.css";
import "../styles/productDetails.css";

function isEmail(v) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
}

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const nextPath = location.state?.nextPath || "/";

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");

    if (!isEmail(email)) {
      setErr("Please enter a valid email.");
      return;
    }
    if (!/^\d{4}$/.test(pin)) {
      setErr("PIN must be exactly 4 digits.");
      return;
    }

    setBusy(true);
    try {
      if (!auth) {
        throw new Error("Login service is temporarily unavailable.");
      }
      if (!db) {
        throw new Error("Login service is temporarily unavailable.");
      }
      await signInWithEmailAndPassword(
        auth,
        email.trim(),
        `giftekart-pin-${pin}`
      );
      const uid = auth.currentUser?.uid;
      if (!uid) {
        throw new Error("Could not read authenticated user id.");
      }
      const nowIso = new Date().toISOString();
      const profileRef = ref(db, `users/${uid}/profile`);
      const snap = await get(profileRef);
      await set(profileRef, {
        ...(snap.exists() ? snap.val() : {}),
        uid,
        email: email.trim().toLowerCase(),
        authProvider: "password",
        ...(snap.exists()
          ? {}
          : {
              createdAt: nowIso,
              createdAtServer: serverTimestamp(),
            }),
        updatedAt: nowIso,
        updatedAtServer: serverTimestamp(),
        lastLoginAt: nowIso,
        lastLoginAtServer: serverTimestamp(),
      });
      saveAuthSession({ email });
      navigate(nextPath, { replace: true });
    } catch (e2) {
      setErr(e2?.message || "Login failed. Check your email and PIN.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="pd-wrap">
      <div className="journey-panel journey-customize journey-customize--form-only">
        <div className="journey-customize-head">
          <Link to="/" className="journey-link-back">
            ← Back home
          </Link>
          <h1>Login with email & PIN</h1>
          <p>Use the email and 4-digit PIN you set while creating your e-card account.</p>
        </div>

        <form className="journey-form journey-form--wide" onSubmit={onSubmit}>
          <label className="journey-field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </label>

          <label className="journey-field">
            <span>4-digit PIN</span>
            <input
              type="password"
              inputMode="numeric"
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
              autoComplete="one-time-code"
              required
            />
          </label>

          {err ? <p className="pd-error journey-inline-err">{err}</p> : null}

          <div className="journey-form-actions pd-customize-actions">
            <button type="submit" className="pd-btn pd-btn-pay" disabled={busy}>
              {busy ? "Logging in…" : "Login"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
